import Claws from './claws'
import Faq from 'containers/claws-nft/faq'
// import Variants from './variants'
// import GuildLine from './guildline'

const MissionPage = () => {
  return (
    <>
      <Claws />
      <Faq dataType="claws" />
      {/*<Variants />*/}
      {/*<GuildLine />*/}
    </>
  )
}

export default MissionPage
